import DefaultWidgetTemplate from '../DefaultWidgetTemplate';

export default function SurveyDefaultWidget({ module }) {
  return (
    <DefaultWidgetTemplate
      module={module}
      route="user_module_survey_home"
    />
  );
}
